import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';


import { Observable, Subject, ReplaySubject, of } from 'rxjs';
import { UserInfoService, LoginInfoInStorage } from './user-info.service';
import { ApiRequestService } from './api-request.service';
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { share, delay } from 'rxjs/operators';

export class LookupData {
    public lookupKey: String = null;
    public lookupCd: String = null;
    public lookupValue: String = null;
    public sortOrder: String = null;
    public criteriaLookupKey: String = null;

}

@Injectable()
export class LookupDataService {
    constructor(
        private http: Http,
        private apiRequest: ApiRequestService,
        public appMetadataHandler: AppMetadataHandler
    ) { }

    customComponentsList = [];

    getProductLookup(product) {
        let lookupDataSubject: Subject<any> = new Subject<any>();
        let lookupServiceData: any = {};
        // let lookupObject:any={}
        let lookupObject = new LookupData();

        let pathVariables = [];
        pathVariables.push(product);
        let lookupServiceURL = 'fetchByPlantypeAndProductFamilyAndBaseplan';
        this.apiRequest.getCallWithAPIMapper(lookupServiceURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                lookupDataSubject.next(jsonResp);
            })

        return lookupDataSubject;
    }

    getExclusionsForProduct(productId) {
        let exclusionDataSubject: Subject<any> = new Subject<any>();
        let pathVariables = [];
        pathVariables.push(productId);
        let exclusionServiceURL = 'fetchProductExclusionByProductID';
        this.apiRequest.getCallWithAPIMapper(exclusionServiceURL, null, null, pathVariables)
            .subscribe(jsonResp => {
                exclusionDataSubject.next(jsonResp);
            })
        return exclusionDataSubject;
    }

    lookupCacheMap = {}
    lookupSubjects = {}
    getLookup(lookupCd, disableSort?, criteriaFilteredLookup?): Observable<any> {
        let lookupDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        let lookupServiceData: any = {};
        // let lookupObject:any={}
        let lookupObject = new LookupData();
        let lookupDataList: LookupData[] = [];

            if (this.appMetadataHandler['sortOrderLookups'].includes(lookupCd))
                disableSort = true;

            if (this.lookupCacheMap[lookupCd]) {      
                return of(this.filterLookupData(this.lookupCacheMap[lookupCd], criteriaFilteredLookup)).pipe(delay(100));
            }
            else if (this.lookupSubjects[lookupCd]) {
                return this.lookupSubjects[lookupCd]
            }
            else {
                this.lookupSubjects[lookupCd] = new Subject();
                let pathVariables = [];
                pathVariables.push(lookupCd);
                let lookupServiceURL = 'lookupMaster';
                //let lookupServiceURL = 'master/lookupMaster/v2/' + lookupCd;
                this.apiRequest.getCallWithAPIMapper(lookupServiceURL, null, null, pathVariables).pipe(share())
                    .subscribe(jsonResp => {
                        lookupServiceData = {
                            data: jsonResp
                        }
                        // if (jsonResp && Array.isArray(jsonResp) && jsonResp.length > 0 && jsonResp.find(e => true).lookupdata) {
                        //     let lookupData = jsonResp.find(e => true).lookupdata;
                        //     for (var i = 0; i < lookupData.length; i++) {
                        //         lookupObject.lookupKey = lookupData[i].lookupKey;
                        //         lookupObject.lookupCd = jsonResp.find(e => true).lookupCd;
                        //         lookupObject.lookupValue = lookupData[i].lookupValue;
                        //         lookupObject.sortOrder = lookupData[i].sortOrder;
                        //         lookupObject.criteriaLookupKey = lookupData[i].criteriaLookupKey;
                        //         lookupDataList.push(lookupObject);
                        //         lookupObject = new LookupData();
                        //         this.extractLabels(lookupData[i].lookupKey, lookupData[i].lookupValue, jsonResp.find(e => true).lookupCd)
    
                        //     }
                        // }  

                        for (var i = 0; i < jsonResp.length; i++) {
                            lookupObject.lookupKey = jsonResp[i].lookupKey;
                            lookupObject.lookupCd = jsonResp[i].lookupCd;
                            lookupObject.lookupValue = jsonResp[i].lookupValue;
                            lookupObject.sortOrder = jsonResp[i].sortOrder;
                            lookupDataList.push(lookupObject);
                            lookupObject = new LookupData();
                            this.extractLabels(jsonResp[i].lookupKey, jsonResp[i].lookupValue, jsonResp[i].lookupCd)

                        }
                        //lookupValues sorted alphabetically in list for all Lookups
                        if (!disableSort)
                            lookupDataList = this.sortObject('lookupValue', lookupDataList, 'asc')
                        else
                            lookupDataList = this.sortObject('sortOrder', lookupDataList, 'asc')

                        if (!this.appMetadataHandler.featureFlags.enableCacheEmptyLookups &&
                            Array.isArray(lookupDataList) &&
                            lookupDataList.length > 0) {
                            this.lookupCacheMap[lookupCd] = lookupDataList
                        }
                        else if (this.appMetadataHandler.featureFlags.enableCacheEmptyLookups) {
                            this.lookupCacheMap[lookupCd] = lookupDataList
                            this.lookupSubjects[lookupCd].next(this.filterLookupData(lookupDataList, criteriaFilteredLookup)); // incidentList is a Subject and emits an event thats being listened to by the components
                        }
                        this.lookupSubjects[lookupCd].next(this.filterLookupData(lookupDataList, criteriaFilteredLookup));

                    })
            }
        return this.lookupSubjects[lookupCd];
    }

    filterLookupData(lookupList, criteriaFilteredLookup?) {
        let output = [];
        if (criteriaFilteredLookup) {
            for (var i = 0; i < lookupList.length; i++) {
                if (criteriaFilteredLookup.indexOf(lookupList[i].lookupKey) !== -1) {
                    output.push(lookupList[i]);
                }
            }
        } else {
            output = JSON.parse(JSON.stringify(lookupList));
        }
        return output;
    }

    sortObject(k, o, orderby) {
        return o.sort(this.compareValues(k, orderby))
    }

    compareValues(key, order) {
        return function (a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }

            const varA = (typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ? (comparison * -1) : comparison
            );
        };
    }

    getLookup_old(lookupCd): Observable<any> {
        let lookupDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        let lookupServiceData: any = {};
        // let lookupObject:any={}
        let lookupObject = new LookupData();
        let lookupDataList: LookupData[] = [];
        let lookupServiceURL = 'lookupMaster' + lookupCd;

        if (this.lookupCacheMap[lookupCd]) {
            return of(this.lookupCacheMap[lookupCd]).pipe(delay(100));
        }
        else if (this.lookupSubjects[lookupCd]) {
            return this.lookupSubjects[lookupCd]
        }
        else {
            this.lookupSubjects[lookupCd] = new Subject();
            let pathVariables = [];
            pathVariables.push(lookupCd);
            let lookupServiceURL = 'lookupMaster';
            this.apiRequest.getCallWithAPIMapper(lookupServiceURL, null, null, pathVariables).pipe(share())
                .subscribe(jsonResp => {
                    lookupServiceData = {
                        data: jsonResp
                    }

                    for (var i = 0; i < jsonResp.length; i++) {
                        lookupObject.lookupKey = jsonResp[i].lookupKey;
                        lookupObject.lookupCd = jsonResp[i].lookupCd;
                        lookupObject.lookupValue = jsonResp[i].lookupValue;
                        lookupObject.sortOrder = jsonResp[i].sortOrder;
                        lookupDataList.push(lookupObject);
                        lookupObject = new LookupData();
                        this.extractLabels(jsonResp[i].lookupKey, jsonResp[i].lookupValue, jsonResp[i].lookupCd)

                    }
                    if (!this.appMetadataHandler.featureFlags.enableCacheEmptyLookups &&
                        Array.isArray(lookupDataList) &&
                        lookupDataList.length > 0) {
                        this.lookupCacheMap[lookupCd] = lookupDataList
                    }
                    else if (this.appMetadataHandler.featureFlags.enableCacheEmptyLookups) {
                        this.lookupCacheMap[lookupCd] = lookupDataList
                        this.lookupSubjects[lookupCd].next(lookupDataList); // incidentList is a Subject and emits an event thats being listened to by the components
                    }
                    this.lookupSubjects[lookupCd].next(lookupDataList);

                })
        }

        return this.lookupSubjects[lookupCd];
    }

    getLookupList(listOflookupCd): Observable<any> {
        let lookupDataSubject: Subject<any> = new Subject<any>();
        let lookupServiceURL = 'getLookupDataListV2';
        let payload: any = []

        listOflookupCd.forEach(lookupCd => {
            if (!this.lookupCacheMap[lookupCd]) {
                let lookupReqItem = { lookupCd: lookupCd }
                payload.push(lookupReqItem)
            }
        });
        this.apiRequest.postCallWithAPIMapper(lookupServiceURL, payload)
            .subscribe(jsonResp => {
                let lookupResponseList = Object.assign([], jsonResp);
                lookupResponseList.forEach(lookupCd => {
                    this.lookupCacheMap[lookupCd.lookupCd] = lookupCd.lookUpList;
                    if (lookupCd.lookupdata && Array.isArray(lookupCd.lookupdata) && lookupCd.lookupdata.length > 0) {
                        lookupCd.lookupdata.forEach(lookup => {
                            this.extractLabels(lookup.lookupKey, lookup.lookupValue, lookupCd.lookupCd)
                        });
                    }
                });

                console.log("technicalLabelMap")
                console.log(this.technicalLabelMap)
                lookupDataSubject.next(lookupResponseList);
                lookupDataSubject.complete();

            })

        return lookupDataSubject;
    }

    technicalLabelMap = {}
    technicalLabelLookupSpecificMap = {}
    extractLabels(key, value, lookupCd) {
        if (key && lookupCd && value) {
            if (!this.technicalLabelLookupSpecificMap[lookupCd])
                this.technicalLabelLookupSpecificMap[lookupCd] = {}
            this.technicalLabelLookupSpecificMap[lookupCd][key] = value
            this.technicalLabelMap[key] = value

        }
    }

    addLookupDataToCache(key, value, lookupCd) {
        if (key && value && lookupCd) {
            let lookup = new LookupData();
            lookup.lookupKey = key;
            lookup.lookupValue = value;
            lookup.lookupCd = lookupCd;
            if (this.lookupCacheMap[lookupCd] && Array.isArray(this.lookupCacheMap[lookupCd])) {
                this.lookupCacheMap[lookupCd] = this.uniquePushInArray(this.lookupCacheMap[lookupCd], lookup, 'lookupKey')
            } else {
                this.lookupCacheMap[lookupCd] = [lookup];
            }
            this.extractLabels(key, value, lookupCd)
        }
    }

    addLookupListToCache(list, lookupCd) {
        if (list && list.isArrayIterable() && lookupCd) {
            if (this.lookupCacheMap[lookupCd] && this.lookupCacheMap[lookupCd].isArrayIterable()) {
                list.forEach((lookup, index) => {
                    this.lookupCacheMap[lookupCd] = this.uniquePushInArray(this.lookupCacheMap[lookupCd], list[index], 'lookupKey')
                });
            } else {
                this.lookupCacheMap[lookupCd] = JSON.parse(JSON.stringify(list));
            }
            list.forEach(lookup => {
                this.extractLabels(lookup.lookupKey, lookup.lookupValue, lookupCd)
            });
        }
    }

    setLookupListToCache(list, lookupCd) {
        if (list && list.isArrayIterable() && lookupCd) {
            this.lookupCacheMap[lookupCd] = JSON.parse(JSON.stringify(list));
            list.forEach(lookup => {
                this.extractLabels(lookup.lookupKey, lookup.lookupValue, lookupCd)
            });
        }
    }

    uniquePushInArray(list = [], item, uniqueKey?) {
        if (Array.isArray(list) && item) {
            if (uniqueKey) {
                let foundIndex = list.findIndex(e => e[uniqueKey] == item[uniqueKey])
                if (foundIndex != -1) {
                    list.splice(foundIndex, 1, item)
                }
                else {
                    list.push(item)
                }
            }
            else {
                if (!list.includes(item)) {
                    list.push(item)
                }
            }
        }

        return list
    }
}
